import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useFolderStore } from "../../store/folderStore";
import { useDarkMode } from "../../context/darkModeContext";

// image from public folder
const Danger = `${process.env.PUBLIC_URL}/assets/danger.webp`;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const DeleteFolderAlert = ({
  open,
  onClose,
  id,
  folderName,
  owner,
  onRecycled,
}) => {
  const { darkMode } = useDarkMode();

  const recycleFolder = useFolderStore((state) => state.recycleFolder);

  // const removeFolder = useFolderStore((state) => state.removeFolder);

  const setRefreshFolders = useFolderStore((state) => state.setRefreshFolders);

  const setRefreshRecycleFolders = useFolderStore(
    (state) => state.setRefreshRecycleFolders
  );

  // const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [severity, setSeverity] = useState("success");

  const [message, setMessage] = useState("");

  // const openDialog = () => {
  //   setOpen(true);
  // };

  const closeDialog = () => {
    if (!loading) {
      onClose();
    }
  };

  const showToast = (type, text) => {
    setSeverity(type);
    setMessage(text);
    setSnackbarOpen(true);
  };

  const handleDelete = async () => {
    setLoading(true);

    try {
      await recycleFolder(id);

      // removeFolder(id);

      // setRefreshFolders(true);

      // setRefreshRecycleFolders(true);

      onRecycled?.(id);

      showToast("success", "Folder moved to Recycle Bin.");

      setTimeout(() => {
        onClose();
      }, 700);
    } catch (error) {
      console.error(error);

      showToast(
        "error",
        error?.response?.data?.detail || "Unable to move folder to Recycle Bin."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <Dialog open={open} onClose={closeDialog} maxWidth="xs" fullWidth>
        <DialogContent className={darkMode ? "bg-gray-900 text-white" : ""}>
          <div className="flex flex-col items-center">
            <img src={Danger} alt="" className="w-24 h-24" />

            <h2 className="font-bold text-xl mt-4">Delete Folder?</h2>

            <p className="text-center mt-3 text-sm opacity-80">
              The folder
              <br />
              <b>{folderName}</b>
              <br />
              will be moved to the Recycle Bin.
            </p>

            <p className="text-center text-sm mt-2 opacity-70">
              You can restore it later from Recycle Bin.
            </p>

            <div className="flex gap-3 mt-6 w-full">
              <button
                className="flex-1 rounded-lg border py-2"
                disabled={loading}
                onClick={closeDialog}
              >
                Cancel
              </button>

              <button
                disabled={loading}
                onClick={handleDelete}
                className="flex-1 rounded-lg bg-red-600 text-white py-2"
              >
                {loading ? (
                  <CircularProgress color="inherit" size={18} />
                ) : (
                  "Delete"
                )}
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert severity={severity} onClose={() => setSnackbarOpen(false)}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DeleteFolderAlert;
